import React, {Component} from 'react';
import {UserContext} from "../auth/Auth";
import LoginModal from "../modals/LoginModal";
import RegisterSupplierModal from "./RegisterSupplierModal";

class RegisterSupplierButton extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showLoginModal: false,
        showRegisterModal: false
    };

    render() {
        return (
            <li className="p-l-1" style={{lineHeight: '50px'}}>
                <button type="button" className="btn btn-primary"
                        onClick={() => this.registerSupplier()}>
                    <i className="fa fa-handshake-o"/> Продай паллеты сейчас. Дорого!
                </button>
                <span style={{color: 'white', marginLeft: 15}}>Хочешь купить поддон сейчас? Звони 8(499) 6475062</span>
                <LoginModal show={this.state.showLoginModal}
                            onLogin={() => this.setState({showRegisterModal: true})}
                            onHide={() => this.setState({showLoginModal: false})}/>
                <RegisterSupplierModal show={this.state.showRegisterModal}
                                       onHide={() => this.setState({showRegisterModal: false})}/>
            </li>
        );
    }

    async registerSupplier() {
        let userContext = UserContext.get();

        if (userContext) {
            this.setState({showRegisterModal: true})
        }
        else {
            this.setState({showLoginModal: true})
        }
    }
}

export default RegisterSupplierButton;


// WEBPACK FOOTER //
// ./src/components/RegisterSupplierButton.js